export default __webpack_public_path__ + "static/media/CT.9c8b6c37.png";